var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2.25C4.5 1.00736 5.30589 0 6.3 0H11.7C12.6941 0 13.5 1.00736 13.5 2.25V4.5H15.2907H15.3075H17.1C17.5971 4.5 18 5.00368 18 5.625C18 6.24632 17.5971 6.75 17.1 6.75H16.138L15.3574 20.4103C15.2901 21.5877 14.5064 22.5 13.562 22.5H4.43801C3.49366 22.5 2.70986 21.5877 2.64258 20.4103L1.86199 6.75H0.9C0.402948 6.75 0 6.24632 0 5.625C0 5.00368 0.402948 4.5 0.9 4.5H2.69257H2.70929H4.5V2.25ZM6.3 4.5H11.7V2.25H6.3V4.5ZM4.438 20.25L3.66658 6.75H14.3334L13.562 20.25H4.438ZM7.2 8.99989C7.69707 8.99989 8.1 9.50355 8.1 10.1249V16.8749C8.1 17.4962 7.69707 17.9999 7.2 17.9999C6.70295 17.9999 6.3 17.4962 6.3 16.8749V10.1249C6.3 9.50355 6.70295 8.99989 7.2 8.99989ZM11.7 10.1249C11.7 9.50355 11.2971 8.99989 10.8 8.99989C10.3029 8.99989 9.9 9.50355 9.9 10.1249V16.8749C9.9 17.4962 10.3029 17.9999 10.8 17.9999C11.2971 17.9999 11.7 17.4962 11.7 16.8749V10.1249Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bbca4189d92e9d62b3b12ea7b95d2bc1.svg";
export { ForwardRef as ReactComponent };